import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { CourseList } from "./pages/CourseList";
import GallerySection from "./pages/GallerySection";
import { Helmet } from "react-helmet-async";
import { InquiryGate } from "./components/InquiryGate";

const App: React.FC = () => {
  return (
    <Router>
      <Helmet>
        {/* Primary SEO Title */}
        <title>
          Haifa Defence Academy Agra | Best Sainik & Military School Coaching
          for Class 6 & 9
        </title>

        {/* Primary Meta Description */}
        <meta
          name="description"
          content="Haifa Defence Academy in Agra offers expert coaching for Sainik School, Rashtriya Military School (RMS), RIMC and defence school entrance exams for Class 6 & 9, with hostel, schooling and full exam preparation."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://haifadefenceacademy.com/" />

        {/* Robots */}
        <meta name="robots" content="index, follow" />

        {/* SEO Keywords (used by some tools, not Google) */}
        <meta
          name="keywords"
          content="Haifa defence academy Agra, sainik school coaching near me, sainik school coaching in Agra, sainik school entrance coaching Agra, sainik school exam coaching class 6, sainik school exam coaching class 9, sainik school preparation for class 6, sainik school preparation for class 9, sainik school academy near me, military school coaching near me, military school coaching in Agra, military school entrance coaching, military school exam preparation, RMS coaching near me, RMS coaching for class 6 in Agra, rashtriya military school coaching Agra, UP sainik school coaching, UP sainik school entrance coaching, UP sainik school preparation, defence academy in Agra, defence coaching institute in Agra, best sainik school coaching in Agra, best military school coaching in Agra, coaching for sainik school exam, defence school preparation coaching, defence coaching for school students, sainik school coaching phone number, defence academy contact number, defence coaching enquiry"
        />

        {/* Open Graph for Social Sharing */}
        <meta
          property="og:title"
          content="Haifa Defence Academy Agra | Best Sainik & Military School Coaching for Class 6 & 9"
        />
        <meta
          property="og:description"
          content="Join Haifa Defence Academy in Agra for top Sainik School, RMS, RIMC and defence school entrance coaching with hostel and schooling facilities."
        />
        <meta
          property="og:url"
          content="https://haifadefenceacademy.com/"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Haifa Defence Academy" />
      </Helmet>

      <InquiryGate /> {/* 🚫 BLOCKS ENTIRE SITE */}
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/courses" element={<CourseList />} />
        <Route path="/gallery" element={<GallerySection />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
